import cvrValidator from 'foundation/js/inputValidators/cvrValidator'
import emailValidator from 'foundation/js/inputValidators/emailValidator'
import isBoolean from 'foundation/js/inputValidators/isBoolean'
import nameValidator from 'foundation/js/inputValidators/nameValidator'
import nonEmptyStringValidator from 'foundation/js/inputValidators/nonEmptyStringValidator'
import phoneValidator from 'foundation/js/inputValidators/phoneValidator'

export default [
    {
        name: 'companyName',
        value: '',
        isValid: false,
        validator: nonEmptyStringValidator
    },
    {
        name: 'firstName',
        value: '',
        isValid: false,
        validator: nameValidator
    },
    {
        name: 'lastName',
        value: '',
        isValid: false,
        validator: nameValidator
    },
    {
        name: 'email',
        value: '',
        isValid: false,
        validator: emailValidator
    },
    {
        name: 'phone',
        value: '',
        isValid: false,
        validator: (value) => value === '' || phoneValidator(value)
    },
    {
        name: 'companyAddress',
        value: '',
        isValid: false,
        validator: nonEmptyStringValidator
    },
    {
        name: 'companyPostalCode',
        value: '',
        isValid: false,
        validator: nonEmptyStringValidator
    },
    {
        name: 'companyCity',
        value: '',
        isValid: false,
        validator: nonEmptyStringValidator
    },
    {
        name: 'companyWebsite',
        value: '',
        isValid: false,
        validator: () => true
    },
    {
        name: 'companyLogo',
        value: [],
        isValid: false,
        validator: () => true
    },
    {
        name: 'isAnonymous',
        value: false,
        isValid: false,
        validator: isBoolean
    },
    {
        name: 'taxDeduction',
        value: false,
        isValid: false,
        validator: isBoolean
    },
    {
        dependentField: 'taxDeduction',
        dependentFieldValue: false,
        dependentFieldValidator: (value) => value === false,
        name: 'cvr',
        value: '',
        isValid: false,
        validator: cvrValidator
    }
]
